/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { useEffect, useRef, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CreateInviteForm from '../../../../components/invite/createForm';
import SelectLocationsComponent from '../../../../components/invite/selectLocationsTable';
import { getUserDetails } from '../../../../redux/slices/user/userDetails';
import { useNavigate, useParams } from 'react-router-dom';
import { getTeamMemeberDetails } from '../../../../redux/slices/accounts/team/team';

import { T, useTranslate } from '@tolgee/react';
import { PATH_PAGE } from '../../../../routes/paths';
import LoadingCard from '../../../../components/invite/loadingCard';
import { ACCESS_TYPE_SELECTED } from '../../../../config/roles';

const EditUser: React.FC = () => {
  const [cloudAccessType, setCloudAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  const [cockpitAccessType, setCockpitAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  const formComponentRef = useRef(null);
  const { t } = useTranslate();
  const { uuid } = useParams();
  const [selectedLocations, setSelectedLocations] = useState(null);
  const [selectedClouds, setSelectedClouds] = useState(null);
  const {
    teamMember: { 
      locations_with_access, 
      clouds_with_access, 
      isLoading,
      location_access_type,
      cloud_access_type,
      is_owner
    }
  } = useSelector((state: any) => state.team);
  useEffect(() => {
    if (!isLoading) {
      setSelectedLocations(locations_with_access.map((item) => item.uuid));
      setSelectedClouds(clouds_with_access.map((item) => item.uuid));
      
      // Initialize access types from team member data
      if (location_access_type !== undefined && location_access_type !== null) {
        setCockpitAccessType(location_access_type);
      }
      if (cloud_access_type !== undefined && cloud_access_type !== null) {
        setCloudAccessType(cloud_access_type);
      }
    }
  }, [isLoading, locations_with_access, clouds_with_access, location_access_type, cloud_access_type]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserDetails() as any);
    dispatch(getTeamMemeberDetails(uuid) as any);
  }, [dispatch]);
  const {
    teamMember: { isLoading: teamMemberLoading }
  } = useSelector((state: any) => state.team);
  const [cockpitRole, setCockpitRole] = useState<any>(null);
  const [cloudRole, setCloudRole] = useState<any>(null);

  const navigate = useNavigate();
  return (
    <Container>
      <div>
        <a
          onClick={() => {
            navigate(PATH_PAGE.team_management);
          }}
          className={'badge bg-secondary text-dark cursor-pointer'}
        >
          <T keyName={'back_button.back'}></T>
        </a>
      </div>
      <div className="m-2" />
      {teamMemberLoading ? (
        <LoadingCard />
      ) : (
        <CreateInviteForm
          cockpitAccessType={cockpitAccessType}
          cloudAccessType={cloudAccessType}
          ref={formComponentRef}
          setCockpitRole={setCockpitRole}
          setCloudRole={setCloudRole}
          userUpdate={true}
          uuid={uuid}
          selectedLocations={selectedLocations}
          selectedClouds={selectedClouds}
          isOwner={is_owner}
        />
      )}
      <div className="m-2" />
      {!is_owner && !isLoading && selectedLocations != null && selectedClouds != null && (
        <SelectLocationsComponent
          cockpitAccessType={cockpitAccessType}
          setCloudAccessType={setCloudAccessType}
          setCockpitAccessType={setCockpitAccessType}
          cloudAccessType={cloudAccessType}
          cockpitRole={cockpitRole}
          cloudRole={cloudRole}
          selectedClouds={selectedClouds}
          setSelectedClouds={setSelectedClouds}
          setSelectedLocations={setSelectedLocations}
          selectedLocations={selectedLocations}
        />
      )}
      {!is_owner && !teamMemberLoading && (
        <div className=" mt-2 p-4 card">
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                navigate(PATH_PAGE.team_management);
              }}
              size="sm"
              variant="secondary"
            >
              {t('buttons.cancel')}
            </Button>
            <div className="m-2" />
            <Button
              onClick={() => {
                if (formComponentRef.current)
                  formComponentRef.current?.submitForm()();
              }}
              size="sm"
            >
              {t('invite.createForm.save')}
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
};
export default EditUser;
